export const REMIX_DEFAULT_TEXTS = {
    Next: {},
    Restart: {},
    Return: {},
    'See result': {},
    'Number of moves': {},
    'Best Results': {},
    'Your result': {},
    'Sign in to play': {},
    'Your code': {},
    Nickname: {},
    'Ok!': {},
    'Access is closed': {},
    'The code is entered incorrectly or has expired.': {},
    'Thanks for the game! You have used all your attempts so far.\nYou can see your best score in the rankings below.': {},
    Back: {},
    'First name': {},
    'Last name': {},
    Email: {},
    'Phone number': {},
    'Agree with': {},
    'Privacy Policy': {},
    Company: {},
    'Click to flip': {},
}
